import { Component, inject, InjectionToken } from '@angular/core';
import { base64ToFile, ImageCroppedEvent } from 'ngx-image-cropper';
import { Observable, of } from 'rxjs';
import AppValues from 'src/app/common/app.values';
import { DialogCropData, MessageLevel } from 'src/app/interfaces';
import { NotificationState } from '../../notifications.state';
import { DialogActionTypes } from '../dialogs.enum';

export const CROP_IMAGE_DIALOG_DATA = new InjectionToken<DialogCropData>(`CROP_IMAGE_DIALOG_DATA`);

@Component({
  selector: 'app-dialog-crop',
  templateUrl: './dialog-crop.component.html',
  styleUrls: ['./dialog-crop.component.scss'],
})
export class DialogCropComponent extends NotificationState {
  public readonly CROPPER_WIDTH: number = AppValues.CROPPER_WIDTH;
  public readonly CROPPER_HEIGHT: number = AppValues.CROPPER_HEIGHT;

  public readonly modalArguments = inject(CROP_IMAGE_DIALOG_DATA);
  public readonly hasUnsavedChanges$: Observable<boolean> = of(false);

  protected notificationLevel: MessageLevel = 'INFO';

  public productImageToUpload: File;

  public imageCropped(event: ImageCroppedEvent): void {
    const originalImageFile: File = this.modalArguments.file;

    if (originalImageFile) {
      this.productImageToUpload = new File([base64ToFile(event.base64)], originalImageFile.name, {
        lastModified: originalImageFile.lastModified,
        type: originalImageFile.type,
      });
    }
  }

  public actionsHandler(action: DialogActionTypes): void {
    this.dialogActions[action]();
  }

  public submit(): void {
    this.activeModal.close(this.productImageToUpload);
  }

  public override confirmAction(): void {
    this.activeModal.close(this.productImageToUpload);
  }
}
